import { render, staticRenderFns } from "./POItemsMatch.vue?vue&type=template&id=034d6477&scoped=true&"
import script from "./POItemsMatch.vue?vue&type=script&lang=js&"
export * from "./POItemsMatch.vue?vue&type=script&lang=js&"
import style0 from "./POItemsMatch.vue?vue&type=style&index=0&id=034d6477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d6477",
  null
  
)

export default component.exports